// @flow

import type { FilesState, FilesAction } from 'stores/flow-type/files.type';

import {
  UPLOAD_FILES_REQUEST,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAILURE
} from 'stores/flow-type/files.type';

const initialState: FilesState = {
  filesLoading: false,
  filesSuccess: false,
  error: undefined
};

const filesReducers = (state: FilesState = initialState, action: FilesAction) => {
  switch (action.type) {
    case UPLOAD_FILES_REQUEST:
      return { ...state, filesLoading: true, filesSuccess: false };
    case UPLOAD_FILES_SUCCESS: {
      return {
        ...state,
        filesLoading: false,
        filesSuccess: true,
        error: undefined
      };
    }
    case UPLOAD_FILES_FAILURE:
      return {
        ...state,
        filesLoading: false,
        filesSuccess: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default filesReducers;
